import { GreenTickCircle } from "assets/icons";
import "./style.scss";
import Button from "components/BaseWidgets/button";
import { AccountDetails } from "../../helper";
import CardLayout from "components/Settings/components/CardLayout";
import { useState } from "react";
import UpdateModal from "../UpdateModal";
import { retrieveToken } from "utils/storage";
import OtpModal from "components/LandingScreen/components/OtpModal";
import { useSendOtp, useVerifyOtp } from "hooks/api/useSettings";
import { useSelectCode } from "hooks/api/useListing";
import { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { storeToken } from "utils/storage";

function DetailsCards({ data, updateCredentials, setIsVerified,update,setUpdate }) {
  const [modal, setModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  
  const updatedMail = retrieveToken("updatedMail");
  const updatedMobile = retrieveToken("updatedMobile");
  const updatedCountryCode = retrieveToken("updatedCountryCode");
  const queryClient = useQueryClient();

  // otp verification api
  const { mutate: otpSubmit, isLoading } = useVerifyOtp({
    onSuccess: () => {
      setOtpModal(false);
      updateApiCall();
      queryClient.invalidateQueries({ queryKey: ["my-profile"] });
      setIsVerified(true);
      storeToken("isVerifiedTemp",true );
    },
  });

  const { mutate: sendOtp, isLoading: sendLoading } = useSendOtp({
    onSuccess: () => {
      setOtpModal(true);
    },
  });

  const { data: countrylist } = useSelectCode({ search_key: "" });
  const CountryCodes = useMemo(() => {
    return (
      countrylist?.country_codes?.map((item) => ({
        value: item.id,
        label: item.code,
        phone_length: item.phone_length,
      })) || []
    );
  }, [countrylist]);

  const selectedCountry = CountryCodes.find(
    (item) => String(item.value) === String(updatedCountryCode),
  );

  const selectedDialCode = selectedCountry ? selectedCountry.label : "";

  const updateApiCall = () => {
    if (update === "mail") {
      const payload = { email: updatedMail };
      updateCredentials(payload);
      return;
    }
    const payload = {
      phone: updatedMobile,

      country_code: updatedCountryCode || "+91",

    };
    updateCredentials(payload);
    return;
  };

  const accountDetail = AccountDetails(data, updatedMail, updatedMobile);

  return (
    <>
      <CardLayout className="account-card-wrapper">
        {accountDetail.map((item, i) => (
          <div key={i} className="card-container">
            <div className="flex flex-col gap-1">
              <span className="font-title-normal">{item?.title}</span>
              <p
                className="font-title-xs fw-500
          "
              >
                {item?.description}
              </p>
            </div>
            <div className="flex items-center flex-wrap justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="font-title-normal fw-600">
                  {item.id === "mobile"
                    ? updatedMobile
                      ? `${selectedDialCode} ${updatedMobile}`
                      : data?.phone
                        ? `${data?.countrycode || ""} ${data?.phone}`
                        : "Not provided"
                    : item.value}
                </span>
                {item?.status === "verified" && (
                  <span className="verified-icon">
                    <GreenTickCircle />
                  </span>
                )}
              </div>
              <div className="flex items-center flex-wrap button-container">
                {item?.status === null && item.value != "Not provided" ? (
                  <Button
                    isLoading={sendLoading}
                    onClick={() => {
                      if (item?.id === "mail") {
                        setUpdate("mail");
                        sendOtp({
                          identifier: updatedMail || data?.email,
                        });
                      } else {
                        setUpdate("mobile");
                        sendOtp({
                          identifier: updatedMobile || data?.phone,
                          countrycode: Number(updatedCountryCode),
                        });
                      }
                    }}
                    variant="link"
                  >
                    Verify
                  </Button>
                ) : null}
                <Button
                  onClick={() => {
                    setIsVerified(false);
                    if (item?.id === "mail") {
                      setModal(true);
                      setUpdate("mail");
                    } else {
                      setModal(true);
                      setUpdate("mobile");
                    }
                  }}
                  variant="link"
                >
                  Change
                </Button>
              </div>
            </div>
          </div>
        ))}
      </CardLayout>
      <UpdateModal open={modal} setOpen={setModal} update={update} />
      <OtpModal
        isLoading={isLoading}
        open={otpModal}
        onCancel={() => {
          setOtpModal(false);
        }}
        title="OTP Verification"
        formData={{
          contact:
            update === "mail"
              ? updatedMail || data?.email
              : updatedMobile || data?.phone,
        }}
        onSubmit={(payload) => {
          otpSubmit(payload);
        }}
        onResend={() => {
          if (update === "mail") {
            sendOtp({
              identifier: updatedMail || data?.email,
            });
          } else {
            sendOtp({
              identifier: updatedMobile || data?.phone,
              countrycode: Number(updatedCountryCode),
            });
          }
        }}
      />
    </>
  );
}

export default DetailsCards;
